import {
  CustomerAdvancedSearchResultContactResponseBody,
  CustomerAdvancedSearchResultResponseBody,
} from '@dms/api/customer';

export type CustomerSearchRow =
  | {kind: 'naturalPerson'; customer: CustomerAdvancedSearchResultResponseBody}
  | {kind: 'business'; customer: CustomerAdvancedSearchResultResponseBody}
  | {
      kind: 'businessContact';
      customer: CustomerAdvancedSearchResultResponseBody;
      contact: CustomerAdvancedSearchResultContactResponseBody;
    };

const hasCustomerLevelMatch = (customer: CustomerAdvancedSearchResultResponseBody): boolean =>
  customer.tradeNameMatchType !== 'NONE' ||
  customer.vatNumberMatchType !== 'NONE' ||
  customer.registrationNumberMatchType !== 'NONE' ||
  (customer.foundingPerson?.hasMatch ?? false);

const getMatchingContacts = (
  customer: CustomerAdvancedSearchResultResponseBody
): CustomerAdvancedSearchResultContactResponseBody[] =>
  customer.contacts.filter((contact) => contact.hasMatch);

export const getCustomerSearchRows = (
  customers: CustomerAdvancedSearchResultResponseBody[] | undefined
): CustomerSearchRow[] => {
  if (!customers) {
    return [];
  }

  return customers.flatMap<CustomerSearchRow>((customer) => {
    const rows: CustomerSearchRow[] = [];

    if (hasCustomerLevelMatch(customer)) {
      rows.push(
        customer.discriminator === 'NATURAL_PERSON'
          ? {kind: 'naturalPerson', customer}
          : {kind: 'business', customer}
      );
    }

    for (const contact of getMatchingContacts(customer)) {
      rows.push({kind: 'businessContact', customer, contact});
    }

    return rows;
  });
};

export const getCustomerSearchRowKey = (row: CustomerSearchRow): string =>
  row.kind === 'businessContact' ? `${row.customer.id}-${row.contact.id}` : row.customer.id;
